export const ARCHIV_FREE = '[reine Nummer]';

export const ARCHIV_PREFIX_OBJ = {
    "historischesbildarchiv": ["HAV", "HDG", "HDK", "HDM", "HDI", "HNE"],
    "bertelsmann": ["BK"],
    "betriebsanleitung": ["BA", "TMT"],
    "garantiewartung": ["GB"],
    "print": ["KAL", "P", "W", "WH"],
    "dokumentation": ["Dok"],
    "medienresonanz": ["Med"],
    "presseinformation": ["Pr"],
    "cdrom": ["DVD", ARCHIV_FREE],
    "findbucher": ["FBE"],
    "kleinexponat": ["B", "NA", "NB", "NF", "NM", "NW", "T", "WA"]
}

export const ARCHIV_FIELD = 'archivenumber';

export const CDROM = 'cdrom';


